import { FC, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "../Layout";
import Home from "../../views/Home";
import NotFound from "../../views/NotFound";
import { RouteSkeleton } from "../layout/RouteSkeleton";
import {
    AboutView,
    AuthorView,
    Categories,
    Category,
    CollectionList,
    CollectionView,
    English,
    EpisodeView,
    FindView,
    ListPodcastView,
    AccountView,
    PodcastSeasonView,
    PodcastView,
    PolicyView,
    SubjectListView,
    SubjectView,
    TopListPodcastView,
} from "../LazyImports";

export const AppRoutes: FC = () => {
    return (
        <Suspense fallback={<RouteSkeleton />}>
            <Routes>
                <Route path={"/"} element={<Layout />}>
                    <Route index element={<Home />} />

                    <Route path={"podd"}>
                        <Route path={":slug"}>
                            <Route path={"season/:seasonSlug"} element={<PodcastSeasonView />} />
                            <Route path={":episode"} element={<EpisodeView />} />
                            <Route index element={<PodcastView />} />
                        </Route>
                    </Route>

                    <Route path={"kategori"}>
                        <Route path={":slug"} element={<Category />} />
                        <Route index element={<Categories />} />
                    </Route>

                    <Route path={"upphovsman"}>
                        <Route path={":slug"} element={<AuthorView />} />
                    </Route>

                    <Route path={"samling"}>
                        <Route path={":slug"} element={<CollectionView />} />
                        <Route index element={<CollectionList />} />
                    </Route>

                    <Route path={"fokus"}>
                        <Route path={":slug"} element={<SubjectView />} />
                        <Route index element={<SubjectListView />} />
                    </Route>

                    <Route path={"om"} element={<AboutView />} />
                    <Route path={"policy"} element={<PolicyView />} />
                    <Route path={"hitta"} element={<FindView />} />
                    <Route path={"en"} element={<English />} />
                    <Route path={"poddar"} element={<ListPodcastView />} />
                    <Route path={"konto"} element={<AccountView />} />
                    <Route path={"topplista"} element={<TopListPodcastView />} />
                    <Route path={"topplista/:date"} element={<TopListPodcastView />} />

                    <Route path="*" element={<NotFound />} />
                </Route>
            </Routes>
        </Suspense>
    );
};
